// extracted by mini-css-extract-plugin
export default {"strong":"ReviewAliases_strong__33b6Y","summary":"ReviewAliases_summary__bkhKY","wysiwyg":"ReviewAliases_wysiwyg__iSP7Q"};